import ErrorFallback from 'Components/ErrorFallback'
import { DynamicDrawerMenu } from 'Components/Layout/DrawerMenu/DynamicDrawerMenu'
import AuthoritySelectionRequired from 'Services/common/Features/Authority/Components/AuthoritySelectionRequired/AuthoritySelectionRequired'
import TariffDrawerMenuContent from 'Services/ProductManagement/Features/Tariff/Components/TariffDrawerMenuContent'
import { TariffProvider } from 'Services/ProductManagement/Features/Tariff/Context/tariffContext'
import {
  TariffCatalogCreatePage,
  TariffCatalogEditPage,
  TariffCatalogListPage,
  TariffCatalogProductListPage,
  TariffCreatePage,
  TariffDetailPage,
  TariffEditPage,
  TariffListPage,
  TariffProductEditPage,
  TariffProductListPage
} from 'Services/ProductManagement/Features/Tariff/Pages'
import {
  IS_HSL_SERVICE_ENVIRONMENT,
  IS_WALTTI_SERVICE_ENVIRONMENT,
  LOGIN_PAGE_PATH,
  PRODUCT_MANAGEMENT_ROOT_URL
} from 'Util/constants'
import ProtectedRoute from 'Util/ProtectedRoute'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'

function TariffRoot() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      {/* We are using a context provider to manage the selected tariff id state. 
      This way we can easily access the selected tariff id from the drawer navigation */}
      <TariffProvider>
        <DynamicDrawerMenu drawerMenuContent={<TariffDrawerMenuContent />} />
        <Routes>
          <Route index element={<TariffListPage />} />
          <Route element={<AuthoritySelectionRequired backButtonFallbackPath="./" />}>
            <Route path="create" element={<TariffCreatePage />} />
          </Route>
          <Route path=":id/edit" element={<TariffEditPage />} />
          <Route path=":id/details" element={<TariffDetailPage />} />
          <Route path=":id/products" element={<TariffProductListPage />} />
          <Route
            element={
              <ProtectedRoute
                isAuthenticated={true}
                isAllowed={IS_HSL_SERVICE_ENVIRONMENT}
                authenticationPath={LOGIN_PAGE_PATH}
                restrictedPath={PRODUCT_MANAGEMENT_ROOT_URL}
              />
            }
          >
            <Route path=":id/sales-channels" element={<TariffCatalogListPage />} />
          </Route>
          <Route path=":id/products/:productId/edit" element={<TariffProductEditPage />} />
          <Route element={<AuthoritySelectionRequired backButtonFallbackPath="./" />}>
            <Route path=":id/sales-channels/create" element={<TariffCatalogCreatePage />} />
          </Route>
          <Route path=":id/sales-channels/:catalogId/edit" element={<TariffCatalogEditPage />} />
          <Route
            element={
              <ProtectedRoute
                isAuthenticated={true}
                isAllowed={IS_WALTTI_SERVICE_ENVIRONMENT}
                authenticationPath={LOGIN_PAGE_PATH}
                restrictedPath={PRODUCT_MANAGEMENT_ROOT_URL}
              />
            }
          >
            <Route
              path=":id/sales-channels/:catalogId/products"
              element={<TariffCatalogProductListPage />}
            />
          </Route>
        </Routes>
      </TariffProvider>
    </ErrorBoundary>
  )
}

export default TariffRoot
